module.exports = __webpack_public_path__ + "static/media/Oswald-Light.4be970a1.ttf";